<p-tabs [(value)]="activeTab" class="w-full h-full flex flex-col">
  <p-tablist class="w-full">
    <p-tab value="direct">Chat</p-tab>
    <p-tab value="stream">Stream</p-tab>
    <p-tab value="ai">AI</p-tab>
  </p-tablist>

  <p-tabpanels class="flex-1 overflow-hidden">
    <p-tabpanel value="direct" class="h-full">
      <mi-scroll-container class="h-full">
        <ng-container *ngTemplateOutlet="listTpl; context: { list: directConversations }"></ng-container>
        @if (showLoadMore()) {
          <div class="text-center py-2">
            <p-button [text]="true" size="small" label="Load More" (onClick)="refreshConversations(false, true)" />
          </div>
        }
      </mi-scroll-container>
    </p-tabpanel>

    <p-tabpanel value="stream" class="h-full">
      <mi-scroll-container class="h-full">
        <ng-container *ngTemplateOutlet="listTpl; context: { list: streamConversations }"></ng-container>
        @if (showLoadMore()) {
          <div class="text-center py-2">
            <p-button [text]="true" size="small" label="Load More" (onClick)="refreshConversations(true, true)" />
          </div>
        }
      </mi-scroll-container>
    </p-tabpanel>

    <p-tabpanel value="ai" class="h-full">
      <mi-scroll-container class="h-full">
        <div class="p-menu-item">
          <div class="p-menu-item-content">
            <a
              class="block no-underline cursor-pointer"
              routerLink="/messages/ai-mode-demo"
              routerLinkActive="mi-active-item"
              [routerLinkActiveOptions]="{ exact: true }"
              [queryParamsHandling]="'preserve'"
              (click)="askAi.emit()"
              data-e2e="ask-ai"
            >
              <!-- alwaysShowActions: New chat is the row's primary action, not a hover-only extra like
                   delete. Kept a constant true rather than bound to aiMode - mi-list-item only ever adds
                   its hover-reveal (opacity-0) classes, never removes them, so a false start would stick. -->
              <mi-list-item styleClass="py-3" [alwaysShowActions]="true">
                <ng-container avatar>
                  <mi-avatar icon="mi2-agent-assist" />
                </ng-container>
                <ng-container line1>
                  <span class="text-lg">Ask AI</span>
                </ng-container>
                @if (aiMode) {
                  <div actions class="flex mi-action-button-gap">
                    <mi-round-button
                      icon="mi2-chat-create"
                      tooltip="New chat"
                      tooltipPosition="left"
                      ariaLabel="New chat"
                      data-e2e="ai-new-chat"
                      (click)="$event.preventDefault(); $event.stopPropagation()"
                      (clicked)="newAiChat.emit()"
                    />
                  </div>
                }
              </mi-list-item>
            </a>
          </div>
        </div>
      </mi-scroll-container>
    </p-tabpanel>
  </p-tabpanels>
</p-tabs>

<ng-template #listTpl let-list="list">
  @for (item of list; track item.id; let i = $index) {
    <div class="p-menu-item">
      <div class="p-menu-item-content">
        <a
          id="convo_{{ i }}"
          attr.convoid="{{ item.id }}"
          class="block no-underline"
          routerLink="/messages/{{ item.id }}"
          routerLinkActive="mi-active-item"
          [routerLinkActiveOptions]="{ exact: true }"
          [queryParamsHandling]="'preserve'"
        >
          <mi-list-item styleClass="py-3">
            <ng-container avatar>
              <mi-avatar [name]="item.displayName" [initials]="item.displayName | initials" [hash]="item.id | hash" />
            </ng-container>
            <ng-container line1>
              <span class="text-lg">{{ item.displayName }}</span>
            </ng-container>
            <div actions class="flex mi-action-button-gap">
              <mi-round-button
                icon="mi2-trash"
                iconColor="danger"
                tooltip="Delete conversation"
                tooltipPosition="left"
                ariaLabel="Delete conversation"
                data-e2e="delete-conversation"
                (click)="$event.preventDefault(); $event.stopPropagation()"
                (clicked)="confirmDelete($event, item)"
              />
            </div>
          </mi-list-item>
        </a>
      </div>
    </div>
  }
  @if (!list.length) {
    <div class="text-center text-muted-color py-4">No conversations</div>
  }
</ng-template>
